import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore } from './store/authStore'
import { useThemeStore } from './store/themeStore'
import HomePage from './pages/HomePage'
import EditorPage from './pages/EditorPage'
import ProfilePage from './pages/ProfilePage'

function getSubdomainFromHostname(hostname: string): string {
  const host = hostname.split(':')[0].toLowerCase()
  if (!host) return ''

  if (host === 'oda.bio' || host === 'www.oda.bio') return ''

  if (host.endsWith('.oda.bio')) {
    const sub = host.slice(0, -'.oda.bio'.length)
    return sub === 'www' ? '' : sub
  }

  return ''
}

function HomeOrProfile() {
  const subdomain = getSubdomainFromHostname(window.location.hostname)
  return subdomain ? <ProfilePage subdomainOverride={subdomain} /> : <HomePage />
}

function SubdomainSubpage() {
  const subdomain = getSubdomainFromHostname(window.location.hostname)
  return subdomain ? <ProfilePage subdomainOverride={subdomain} /> : <ProfilePage />
}

function App() {
  const { checkAuth } = useAuthStore()
  const { theme, colorPalette } = useThemeStore()
  const isSubdomainHost = !!getSubdomainFromHostname(window.location.hostname)

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    document.documentElement.setAttribute('data-palette', String(colorPalette))
  }, [theme, colorPalette])

  return (
    <div className="min-h-screen text-[var(--app-fg)]">
      <Routes>
        <Route path="/" element={<HomeOrProfile />} />
        <Route path="/edit" element={<EditorPage />} />
        {isSubdomainHost ? (
          <Route path="/:page" element={<SubdomainSubpage />} />
        ) : (
          <>
            <Route path="/:subdomain/:page" element={<ProfilePage />} />
            <Route path="/:subdomain" element={<ProfilePage />} />
          </>
        )}
      </Routes>
    </div>
  )
}

export default App
